import { makeStyles } from '@material-ui/core';
import { configApiRef, useApi } from '@backstage/core-plugin-api';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 40,
    display: 'block',
  },
});

const LogoFull = () => {
  const classes = useStyles();
  const configApi = useApi(configApiRef);
  const baseUrl = configApi.getOptionalString('app.baseUrl') ?? '';
  const assetBase = baseUrl.replace(/\/$/, '');
  const logoUrl = `${assetBase}/branding/logo-full.svg`;

  return <img className={classes.img} src={logoUrl} alt="Arcus" />;
};

export default LogoFull;
